"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const helpers_1 = require("../tools/helpers");
exports.default = {
    install(vm) {
        Object.assign(vm.prototype, {
            trans: this.trans,
        });
    },
    trans(slug, ...substitutions) {
        return helpers_1.localizeString(slug, ...substitutions);
    },
};
//# sourceMappingURL=trans.js.map